// page loading indicator
/**
 * Use: $().bwLoader(<selector>).start()
 * Use: $().bwLoader(<selector>).stop()
*/
export default (function ( $ ) {
	$.fn.bwLoader = function(element) {
		const el = $(element);
		const spinner = $(`<div id="bwLoaderSpinner" class="bw-loader-spinner">
		<div class="spinner-border text-primary" role="status">
			<span class="sr-only">Loading...</span>
		</div>
	</div>`);

		this.start = () => {
			if(!(el.css("position") === "fixed"
				|| el.css("position") === "relative"
				|| el.css("position") === "absolute")) {
				el.css('position', 'relative');
				el.attr('data-bw-manual-position', '');
			}
			
			el.prepend(spinner);
		}

		this.stop = () => {
			if(el[0].hasAttribute('data-bw-manual-position')) {
				el.css('position', '');
				if (el.attr('style') === '') el.removeAttr('style'); // cleanup if empty
				el.removeAttr('data-bw-manual-position');
			}

			$('#bwLoaderSpinner').remove();
		}

		return this;
	};
})( jQuery );